import { render } from "./user-profile-input.vue?vue&type=template&id=ec845904&scoped=true"
import script from "./user-profile-input.vue?vue&type=script&lang=js"
export * from "./user-profile-input.vue?vue&type=script&lang=js"

import "./user-profile-input.vue?vue&type=style&index=0&id=ec845904&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec845904"]])

export default __exports__